import {
  createPlankToMwdDragChannel,
  isPlankToMwdDragMessage,
  PLANK_TO_MWD_DRAG_PAYLOAD_MAX_AGE_MS,
  PlankToMwdDragPayload,
} from '@/utils/plankToMwdDrag';

let finishActiveDrag: (() => void) | undefined;

/** One native drag per document, independent of virtualized row lifetimes. */
export function startPlankToMwdDrag(source: HTMLElement, payload: PlankToMwdDragPayload) {
  finishActiveDrag?.();
  const channel = createPlankToMwdDragChannel();
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    source.removeEventListener('dragend', finish);
    globalThis.clearTimeout(timeout);
    if (finishActiveDrag === finish) finishActiveDrag = undefined;
    channel?.postMessage({
      type: 'PLANK_MWD_DRAG_END',
      sessionId: payload.sessionId,
      timestamp: payload.timestamp,
    });
    channel?.close();
  };
  const timeout = globalThis.setTimeout(
    finish,
    Math.max(0, payload.timestamp + PLANK_TO_MWD_DRAG_PAYLOAD_MAX_AGE_MS - Date.now()),
  );
  finishActiveDrag = finish;
  // React delegates to its root, which a removed row can no longer bubble to.
  // Keep this listener until native completion/consumption/expiry, NOT row unmount.
  source.addEventListener('dragend', finish);
  if (channel) {
    channel.onmessage = ({ data }: MessageEvent<unknown>) => {
      if (
        isPlankToMwdDragMessage(data) &&
        data.type === 'PLANK_MWD_DROP_CONSUMED' &&
        data.payload.sessionId === payload.sessionId
      )
        finish();
    };
    // Keep one sender for START/END; do not depend on ordering across short-lived senders.
    channel.postMessage({ type: 'PLANK_MWD_DRAG_START', payload });
  }
}
